import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import React from 'react';
import { Translate, withLocalize } from 'react-localize-redux';
import { isClickTo, registerHook, unregisterHook } from "../../store/clickWrapper";

class ChartTopPanelTools extends React.Component {

    items = undefined;
    opener = undefined;
    openerRect = undefined;
    mounted = false;
    tools = {};

    constructor(props) {
        super(props);
        this.state = {
            moreBtnOpen: false,
            visibleTools: [],
            invisibleTools: [],
        }
    }

    componentDidMount() {
        this.mounted = true;
        this.hookId = registerHook(this, (click) => {
            if (this.state.moreBtnOpen && !isClickTo(click, [this.opener, this.items]) && this.mounted) {
                this.setState({ moreBtnOpen: false });
            }
        });
        this.setupToolOffsets(this.props.maxTableWidth);
        const that = this;
        this.updaterInterval = window.setInterval(function () { that.setupToolOffsets(that.props.maxTableWidth); }, 500);

    }

    componentDidUpdate(preState) {
        if (this.props.maxTableWidth !== preState.maxTableWidth) {
            this.setupToolOffsets(this.props.maxTableWidth);
            this.setState({ maxTableWidth: this.props.maxTableWidth });
        }
    }

    componentWillUnmount() {
        this.mounted = false;
        unregisterHook(this.hookId);
        window.clearInterval(this.updaterInterval);
    }

    render() {
        return (
            <>
                <div
                    style={{ display: 'flex' }}
                    onMouseDown={(e) => e.stopPropagation()} onMouseUp={(e) => e.stopPropagation()}
                >
                    {this.state.visibleTools.map(tool =>
                        <div
                            key={tool.toolId}
                            ref={el => this.syncToolDims(tool.toolId, el)}>
                            {tool.component}
                        </div>
                    )}
                </div>
                {this.state.invisibleTools.length > 0 &&
                    <div
                        className={classnames({ 'dropdown is-right': true, 'is-active': this.state.moreBtnOpen })}
                        style={{ margin: "auto 4px auto auto" }}
                    >
                        <div
                            className="toolbox-group hidden-xs dropdown-trigger" ref={(el) => this.syncOpenerDims(el)}
                            style={{ width: '1cm', cursor: "pointer" }}
                            onClick={e => {
                                e.stopPropagation();
                                this.setState({ moreBtnOpen: !this.state.moreBtnOpen });
                            }}
                            onMouseDown={(e) => e.stopPropagation()} onMouseUp={(e) => e.stopPropagation()}
                        >
                            <p className="panel-name"><Translate id="Report.Common.More" /></p>
                            <div id="moreController" className="content">
                                <a className={classnames("rc-button-frame rc-checkbox mobile-icon", { "checked": this.state.moreBtnOpen })} title={this.props.translate("Charts.SubjectList")}>
                                    <FontAwesomeIcon icon="ellipsis-v" />
                                </a>
                            </div>
                        </div>
                        <div className="dropdown-menu" ref={(el) => this.items = el} role="menu">
                            <div
                                className="dropdown-content"
                                onMouseDown={e => e.stopPropagation()} onMouseUp={e => e.stopPropagation()}
                            >
                                {this.state.invisibleTools.map(tool =>
                                    <div key={tool.toolId} className="dropdown-item" style={{ whiteSpace: 'nowrap' }}>
                                        {tool.component}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                }
            </>
        );
    }

    syncOpenerDims = (element) => {
        this.opener = element;
        if (element === null || element === undefined) {
            return;
        }
        const elRect = element.getBoundingClientRect();
        if (this.openerRect === null || this.openerRect === undefined) {
            this.openerRect = elRect;
            return;
        }
        if (elRect.width !== 0 && this.openerRect.width !== elRect.width) {
            this.openerRect = elRect;
        }
    }

    syncToolDims = (key, element) => {
        if (element === null || element === undefined) {
            return;
        }
        const elRect = element.getBoundingClientRect();
        if (this.tools[key] === null || this.tools[key] === undefined) {
            this.tools[key] = elRect;
            return;
        }
        const rect = this.tools[key];
        if (elRect.width !== 0 && rect.width !== elRect.width) {
            this.tools[key] = elRect;
        }
    }

    setupToolOffsets = (maxWidth) => {
        const all = [...this.props.allTools];
        let newVisible = all;
        let newHidden = [];

        if (maxWidth === undefined || maxWidth === 0) {
            this.setState({ visibleTools: newVisible, invisibleTools: newHidden });
            return;
        }
        const toolWidthSum = Object.keys(this.tools).map(b => this.tools[b].width).reduce((a, b) => a + b, 0);
        if (toolWidthSum === 0 || maxWidth < 0 || maxWidth > toolWidthSum) {
            this.setState({ visibleTools: newVisible, invisibleTools: newHidden });
            return;
        }

        newVisible = [];
        newHidden = [];
        let currentW = (this.openerRect || {}).width || 0;
        for (let i = 0; i < all.length; i++) {
            const box = this.tools[all[i].toolId].width;
            if ((currentW + box < maxWidth)) {
                newVisible.push(all[i])
                currentW = currentW + box;
            } else {
                newHidden.push(all[i]);
            }
        }

        this.setState({ visibleTools: newVisible, invisibleTools: newHidden });
        return;
    }
}

export default withLocalize(ChartTopPanelTools);